var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataWorkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 38.7525,
    rx: 39.8947,
    ry: 38.6622,
    fill: "#E6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5875 46.3179C48.2515 46.3179 54.4644 40.2969 54.4644 32.8697C54.4644 25.4424 48.2515 19.4214 40.5875 19.4214C32.9235 19.4214 26.7106 25.4424 26.7106 32.8697C26.7106 40.2969 32.9235 46.3179 40.5875 46.3179Z",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5553 58.0836C21.6866 54.5055 24.7523 51.534 28.4442 49.4681C32.1362 47.4022 36.3243 46.3146 40.5875 46.3146C44.8507 46.3146 49.0389 47.4022 52.7308 49.4681C56.4228 51.534 59.4885 54.5055 61.6198 58.0836",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataWorkerIcon);
export default __webpack_public_path__ + "static/media/data-worker-icon.385e40f0d6b6b0c326dd6410d8d655cd.svg";
export { ForwardRef as ReactComponent };